import Member from './Member';

class Meta {
	constructor(data) {
		this.uid = data.uid;
		this.members = data.members.map(i => new Member(i));
	}
}

export default Meta;
